import { domainMap } from 'config/env'

import { TIER_KEY, TIER_NAME, TIER_PRICE, TIER_PRICE_ID } from 'app-constants'

export const setTierPriceIdCookie = (id: string) => {
  window.sessionStorage.setItem(TIER_PRICE_ID, id)
  return (document.cookie = `${TIER_PRICE_ID}=${id}; domain=${domainMap.get(
    process.env.BUILD_ENV,
  )}; path=/ `)
}

export const getTierPrice = (): number | null => {
  const tierPrice = window.sessionStorage.getItem(TIER_PRICE)
  return tierPrice ? parseInt(tierPrice) : null
}

export const setTierPrice = (tierPrice: number) => {
  return tierPrice && window.sessionStorage.setItem(TIER_PRICE, tierPrice.toString())
}

export const setTierName = (tierName: string) => {
  return tierName && window.sessionStorage.setItem(TIER_NAME, tierName)
}

export const setTierKey = (tierKey: string) => {
  return tierKey && window.sessionStorage.setItem(TIER_KEY, tierKey)
}

export const getTierKey = (): string | null => {
  return window.sessionStorage.getItem(TIER_KEY) || null
}
